import { Config } from '@comall-backend-builder/core/lib/parser';
import { DESIGN_PAGE_TYPES_LIST, DESIGN_PAGE_TYPES } from '../constants/page-design';

const TemplateTabs = (component: any) => {
    const templateTabItems = [
        {
            title: '全部',
            content: {
                component: component,
            },
            params: {},
        },
    ];
    for (const key in DESIGN_PAGE_TYPES) {
        templateTabItems.push({
            //@ts-ignore
            title: DESIGN_PAGE_TYPES[key],
            content: {
                component: component,
            },
            params: { type: key },
        });
    }
    return {
        component: 'Tabs',
        cache: false,
        animated: false,
        items: templateTabItems,
    };
};
const TemplateTabPane = {
    component: 'DataList',
    loadFirstPage: true,
    pagination: {
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '15', '20'],
    },
    grid: { gutter: 16, column: 5 },
    renderItem: 'PageTemplateListItem',
};

export let config: Config = {
    entities: {
        DesignTemplate: {
            apiPath: '/loader/template',
            filters: {
                name: {
                    type: 'string',
                    displayName: '关键字',
                },
            },
            properties: {
                name: {
                    type: 'string',
                    displayName: '模板名称',
                    rules: [
                        { required: true, message: '请输入模板名称.' },
                        { max: 16, message: '最多可输入16个字符.' },
                    ],
                    controlConfig: {
                        placeholder: '请输入模板名称',
                    },
                },
                type: {
                    type: 'string.options.select',
                    displayName: '模板类型',
                    options: [],
                    source: {
                        apiPath: '/loader/design-type',
                    },
                    controlConfig: {
                        placeholder: '请选择',
                        showSearch: false,
                    },
                    rules: [{ required: true }],
                },
                order: {
                    type: 'number.positive',
                    displayName: '排序',
                    defaultValue: '0',
                },
                preview: {
                    type: 'string.image.picker.pzg',
                    rules: [{ required: false }],
                    displayName: '预览图',
                },
                // sturctureFixed: {
                //     type: 'boolean.switch',
                //     displayName: '固定页面结构',
                //     defaultValue: false,
                // },
                // enabled: {
                //     type: 'boolean.switch',
                //     displayName: '启用',
                //     defaultValue: false,
                // },
            },
        },
    },

    components: {
        PageTemplateManageView: {
            component: 'Viewport',
        },
        PageTemplateManagePage: {
            entity: 'DesignTemplate',
            component: 'Card',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                items: [
                    {
                        component: 'GridLayout',
                        style: {
                            marginBottom: 10,
                        },
                        items: [
                            {
                                component: 'Button',
                                text: '新建模板',
                                type: 'primary',
                                icon: 'plus',
                                span: 12,
                                route: 'template/add',
                            },
                            // {
                            //     component: 'PageTemplateFilter',
                            //     span: 12,
                            //     style: {
                            //         float: 'right',
                            //     },
                            // },
                        ],
                    },
                    {
                        component: 'PageTemplateManageTabs',
                    },
                ],
            },
        },
        PageTemplateManageTabs: {
            ...TemplateTabs('PageTemplateTabPane'),
        },
        PageTemplateFilter: {
            component: 'FilterForm',
            direction: 'inline',
            fields: [
                {
                    property: 'name',
                },
            ],
            submit: { text: '搜索' },
        },
        PageTemplateDesignView: {
            component: 'Card',
            title: '装修模板',
            content: {
                component: 'PageTemplateDesign',
                client: ENV.DESIGN_CLIENT_URL,
            },
        },
        PageTemplateTabPane: {
            className: 'template-manage-tabpane',
            ...TemplateTabPane,
            type: 'template',
            grid: { gutter: 8, column: 6 },
        },
        PageTemplateAdd: {
            component: 'Card',
            title: '新建模板',
            content: {
                component: 'PageTemplateAddForm',
            },
        },
        PageTemplateAddForm: {
            component: 'CreateForm',
            entity: 'DesignTemplate',
            fields: [
                {
                    property: 'name',
                },
                {
                    property: 'type',
                },
                {
                    property: 'preview',
                    width: 200,
                    rules: [{ required: false }],
                    controlConfig: {
                        maxCount: 1,
                        multiple: false,
                        fileName: 'fileName',
                        uploadType: 'multi',
                        uploadUrl: `${ENV.API_ROOT}/images`,
                        mode: 'picture-card',
                    },
                    displayConfig: {
                        style: {
                            width: 50,
                        },
                    },
                },
                // { property: 'sturctureFixed' },
                // { property: 'enabled' },
            ],
            labelCol: 10,
            submit: { text: '提交' },
            submitSuccessBehavior: {
                route: 'goBack',
            },
            footer: {
                items: [
                    {
                        text: '取消',
                        htmlType: 'button',
                        type: 'default',
                        route: 'goBack',
                        style: { marginLeft: 16 },
                    },
                ],
            },
            style: {
                width: '400px',
            },
        },
        PageTemplateEdit: {
            component: 'Card',
            title: '设置模板',
            content: {
                component: 'PageTemplateEditForm',
            },
        },
        PageTemplateEditForm: {
            component: 'ModifyForm',
            entity: 'DesignTemplate',
            loaderType: 'get',
            fields: [
                {
                    property: 'name',
                },
                {
                    property: 'type',
                },
                {
                    property: 'preview',
                    width: 200,
                    rules: [{ required: false }],
                    controlConfig: {
                        maxCount: 1,
                        multiple: false,
                        fileName: 'fileName',
                        uploadType: 'multi',
                        uploadUrl: `${ENV.API_ROOT}/images`,
                        mode: 'picture-card',
                    },
                    displayConfig: {
                        style: {
                            width: 50,
                        },
                    },
                },
                // { property: 'sturctureFixed' },
                // { property: 'enabled' },
            ],
            labelCol: 10,
            submit: { text: '提交' },
            submitSuccessBehavior: {
                route: 'goBack',
            },
            footer: {
                items: [
                    {
                        text: '取消',
                        htmlType: 'button',
                        type: 'default',
                        route: 'goBack',
                        style: { marginLeft: 16 },
                    },
                ],
            },
            style: {
                width: '400px',
            },
        },
    },
};
